import { ValuesetCodes } from '@tempus/trials-types';

export const TRIAL_SEARCH_VALUESETS = [
  ValuesetCodes.PATIENT_GENDER,
  ValuesetCodes.STAGE,
  ValuesetCodes.CANCER_COHORT,
  ValuesetCodes.COHORT_CANCER_SOLID_TUMORS,
];
